<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="name">
        <el-input v-model="queryParams.name" clearable placeholder="名称"></el-input>
      </el-form-item>
      <el-form-item  prop="productId">
        <el-input v-model="queryParams.productId" clearable placeholder="套餐ID"></el-input>
      </el-form-item>
      <el-form-item  prop="source">
        <el-select v-model="queryParams.source" filterable clearable placeholder="来源" @change="search">
          <el-option label="运营商" value="1"></el-option>
          <el-option label="系统" value="2"></el-option>
          <el-option label="代理商" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="channel">
        <el-select v-model="queryParams.channel" filterable clearable placeholder="渠道" @change="search">
          <el-option label="ZY国际" value="cmlink"></el-option>
          <el-option label="QC国际" value="Quadcell"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="handleProduct" v-hasPermi="['product:add']">同步套餐</el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="handleInternationalOperator" v-hasPermi="['product:add']">同步运营商</el-button>
        <el-button type="danger" :disabled="productIds.length == 0" icon="el-icon-delete" @click="handleProductDel" v-hasPermi="['product:external:del']">删除套餐</el-button>
      </el-form-item>
    </el-form>
    <div class="table">
      <el-table :data="tableData" border id="out-table" @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center"></el-table-column>
        <el-table-column prop="name" label="套餐名称" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="channel" label="渠道名称" align="center" :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <span v-if="row.channel == 'cmlink'">ZY国际</span>
            <span v-if="row.channel == 'Quadcell'">QC国际</span>
          </template>
        </el-table-column>
        <el-table-column prop="productId" label="套餐ID" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="activationMode" label="套餐计费激活方式" :show-overflow-tooltip="true" align="center" width="160px">
          <template slot-scope="{row}">
            {{transferActivationMode(row.activationMode)}}
          </template>
        </el-table-column>
        <el-table-column prop="type" label="流量限制类型" align="center" width="100px">
          <template slot-scope="{row}">
            {{transferType(row.type)}}
          </template>
        </el-table-column>
        <el-table-column prop="periodType" label="周期类型" align="center" width="100px">
          <template slot-scope="{row}">
            {{transferPeriodType(row.periodType)}}
          </template>
        </el-table-column>
        <el-table-column prop="period" label="套餐周期" align="center" width="120px"></el-table-column>
        <el-table-column prop="monthFlow" label="套餐总量MB" align="center" width="120px">
          <template slot-scope="{row}">
            <span v-if="row.monthFlow == '-1'">无流量限制</span>
            <span v-else>{{row.monthFlow}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center" width="200px" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="mccs" label="国家" align="center" width="280" :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <div class="product-list" v-if="row.mccsList && row.mccsList.length > 0">
              <div class="product-item" v-for="(item,index) in row.mccsList.slice(0, 2)" :key="index" :title="item">
                    <span>{{item}}</span>
              </div>
              <span class="el-dropdown-link" v-if="row.mccsList.length>2" @click="showMoreCountry(row)">
                <i class="el-icon-d-arrow-right el-icon--right"></i>更多
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="source" label="来源" align="center" width="100px" :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <el-tag v-if="row.source == 1">运营商</el-tag>
            <el-tag v-if="row.source == 3">代理商</el-tag>
            <el-tag v-else>系统</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center" width="80px">
          <template slot-scope="{row}">
            <el-tag v-if="row.status == 1">正常</el-tag>
            <el-tag v-else>删除</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" v-if="checkPermi(['product:external:refresh'])">
          <template slot-scope="{row}">
            <el-button size="mini" type="primary" plain @click="handleProductRefresh(row)" icon="el-icon-refresh">刷新</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="queryInfo"
    />
    <el-dialog title="国家列表" :visible.sync="moreCountryOpen" width="700px" append-to-body :close-on-click-modal="false">
      <el-input v-model="searchCountry" placeholder="搜索国家" clearable style="margin-bottom: 15px;"></el-input>
      <el-tag
        v-for="(country, index) in filteredCountries"
        :key="index"
        effect="plain"
        style="margin: 4px"
      >
        {{ country }}
      </el-tag>
    </el-dialog>
  </div>
</template>
<script>
import {syncInternationalProductExternal,syncInternationalOperatorExternal,productExternalPage,delProductExternal} from "@/api/international.js";
export default {
  name: "internationalProduct",
  data() {
    return {
      optCountryList:[],
      // 查询条件
      queryParams: {
        name:undefined,
        productId:undefined,
        channel: undefined
      },
      optOperatorList:[],
      optType: [],
      isDisable: [
        { value: 0, label: "已禁用" },
        { value: 1, label: "启用中" }
      ],
      // 分页器
      page: 1,
      pageSize: 20,
      total: 20,
      // 列表数据
      tableData: [],
      open:false,
      productIds:[],
      moreCountryOpen:false,
      moreCountryData:[],
      searchCountry:""
    };
  },
  computed: {
    adminShow(){
        return this.$store.getters.user.userType =='1'
    },
    filteredCountries() {
      if (!this.searchCountry) {
        return this.moreCountryData;
      }
      const searchTerm = this.searchCountry.toLowerCase();
      return this.moreCountryData.filter(country => 
        country.toLowerCase().includes(searchTerm)
      );
    }
  },
  watch: {
    $route: {
      handler: function(to, from){
        if(to.name == 'internationalProduct'){
          this.queryInfo();
        }
      },
      // 深度观察监听
      deep: true
    }
  },
  methods: {
    // 状态转换
    transferIsDisable(status) {
      let obj = {
        0: "未启用",
        1: "启用中"
      };
      return obj[status];
    },
    transferActivationMode(status) {
      let obj = {
        1: "预订日期或首话单开始计算套餐",
        2: "收到IMSI 的 LU 后开始计算套餐",
        3: "用户 IMSI(HIMSI+VIMSI)的流量使用超过指定限额后"
      };
      return obj[status];
    },
    transferType(status) {
      let obj = {
        1: "周期内限量",
        2: "单日限量"
      };
      return obj[status];
    },

    transferPeriodType(status) {
      let obj = {
        0: "24 小时",
        1: "自然天",
        2: "自然月",
        3: "自然年",
      };
      return obj[status];
    },
    // 获取列表
    queryInfo() {
      let params = {
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      productExternalPage(params).then(res => {
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      });
    },
    // 添加
    handleProduct() {
      syncInternationalProductExternal().then(res=>{
        this.$message.success("外部套餐同步成功");
      })
    },
    handleInternationalOperator(){
        syncInternationalOperatorExternal().then(res=>{
            this.$message.success("外部运营商同步成功");
       })
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.queryInfo();
    },
    // 搜索
    search() {
      this.page = 1;
      this.queryInfo();
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.resetForm("form");
    },
    handleProductRefresh(row){
      let dataBundleId = row.productId
      syncInternationalProductExternal({dataBundleId}).then(res=>{
        this.$message.success("【"+row.name+"】同步成功");
      })
    },
    handleSelectionChange(products){
      this.productIds = products.map(item=>item.productId)
    },
    handleProductDel(){
      let productIds = this.productIds
      this.$modal.confirm('是否确认删除选中的套餐？').then(function() {
        return delProductExternal({productIds});
      }).then(() => {
        this.search();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    showMoreCountry(row){
      this.moreCountryOpen = true
      this.searchCountry = '';
      this.moreCountryData = [];
      this.$nextTick(() => {
        // 使用展开运算符创建新数组
        this.moreCountryData = [...row.mccsList]; 
      });
    }
  },
  created() {
    this.queryInfo();
  }
};
</script>
<style scoped lang="less">
.product-list{
  display: flex; /* 或者 inline-flex */
  flex-wrap: wrap; /* 允许元素在需要时换行 */
  color: #409eff;
  .product-item{
    border: 1px solid #dcdfe6;
    width: 80px; /* 设置子元素的宽度 */
    white-space: nowrap;
    overflow: hidden; /* 隐藏超出容器的文本 */
    text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
    height: 30px; /* 设置子元素的高度 */
    margin: 5px; /* 设置子元素的外边距 */
    background: #ecf5ff; /* 设置背景颜色 */
    line-height: 30px;
    align-content: flex-start;
    border-color: #b3d8ff;
    border-radius: 6px;
  }
  .el-dropdown-link{
    cursor: pointer;
    color: #409EFF;
    margin-left: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 30px;
    margin: 5px;
    line-height: 30px;
    -ms-flex-line-pack: start;
    align-content: flex-start;

  }
}
</style>